<template>
  <div class="main-content">
    <!-- BradCrumb header Start-->
    <section class="inner-header-bg-cap">
      <div class="container">
        <!-- Breadcrumb Start-->
        <div class="section-breadcrumb">
          <div class="container">
            <div class="row">
              <div
                class="col-md-12 justify-content-center align-self-center pb-2"
              >
                <div class="breadcrumb-content">
                  <div class="title-section">
                    <h1 class="title text-center text-white">Capabilities</h1>
                  </div>
                  <div class="breadcrumb-nav">
                    <ul class="breadcrumb-link text-center list-unstyled mb-0">
                      <li class="text-white">
                        <i class="mdi mdi-home theme-light-color pr-2"></i>
                        <a href="index.html">Home</a>
                      </li>
                      <li class="theme-light-color active">Capabilities</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Breadcrumb End -->
      </div>
    </section>
    <!-- BradCrumb header End -->
    <!-- Start Services Top Area -->
    <!-- <section class="section services-inner">
            <div class="container">
                <div class="row">
                    <div class="col-lg-7">
                        <div class="section-title">
                            <span>100 + YEARS OF EXPERIENCE</span>
                            <h2>I4NI's Services</h2>
                        </div>
                        <div id="progress-bar" class="progress-bar-block">

                            <div id="bar-1" class="bar-main-container azure">
                                <div class="wrap">
                                    <div class="bar-container">
                                        <div class="bar"></div>
                                    </div>
                                    <label class="bar-label mb-0">Research and Development</label>
                                    <div class="bar-percentage" data-percentage="46"></div>
                                </div>
                            </div>

                            <div id="bar-2" class="bar-main-container emerald">
                                <div class="wrap">
                                    <div class="bar-container">
                                        <div class="bar"></div>
                                    </div>
                                    <label class="bar-label mb-0">Workforce Development</label>
                                    <div class="bar-percentage" data-percentage="94"></div>
                                </div>
                            </div>

                            <div id="bar-3" class="bar-main-container violet">
                                <div class="wrap">
                                    <div class="bar-container">
                                        <div class="bar"></div>
                                    </div>
                                    <label class="bar-label mb-0">Business Development</label>
                                    <div class="bar-percentage" data-percentage="47"></div>
                                </div>
                            </div>

                            <div id="bar-4" class="bar-main-container yellow">
                                <div class="wrap">
                                    <div class="bar-container">
                                        <div class="bar"></div>
                                    </div>
                                    <label class="bar-label mb-0">Commercialization</label>
                                    <div class="bar-percentage" data-percentage="85"></div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="col-lg-5">
                        <div class="mt-lg-0 mt-5">
                            <img src="../assets/images/images/Incidence_Response.png" alt="" class="img-fluid w-100 ">
                        </div>
                    </div>
                </div>
            </div>
        </section> -->
    <!-- End Services Top Area -->
    <section class="section services-inner">
      <div class="container">
        <div class="section-title text-left z-index9">
          <h2 style="text-align:center;">MoveAmerica Capability Areas​</h2>
          <p style="text-align:center;">
            MoveAmerica offers a comprehensive platform of relevant national
            security expertise to address acknowledged and emerging challenges
            with solutions that can be applied quickly by the U.S. Department of
            Defense, Department of Homeland Security, and other Federal
            Agencies.
          </p>
        </div>
      </div>
    </section>
    <section class="section parallax-bg" id="services">
      <div class="container">
        <div class="service-boxes-area">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6">
              <div
                class="single-service-box mt-30 p-4 bg-white wow fadeIn item"
                data-wow-delay="0.2s"
                data-wow-duration="1s"
              >
                <div class="icon">
                  <!-- <i class="mdi mdi-desktop-mac-dashboard"></i> -->
                  <img src="../assets/images/icons/data-science.svg" alt="" />
                </div>
                <h3>Research and Development</h3>
                <p style="text-align:center;">
                  MoveAmerica’s team has extensive experience in research and
                  development as well as the introduction of new technology. We
                  have both led and supported projects to identify industrial
                  base needs and determine the pathways to preparedness. This
                  includes testing, manufacturing, and supporting systems in
                  order to secure organizations’ networks and network assets.
                </p>
                <p style="text-align:center;">
                  Our scientists and engineers have diverse expertise, with
                  backgrounds in physics, electrical engineering, neuroscience,
                  data analytics, and machine learning, allowing us to be nimble
                  and creative in our approach to problem solving.
                </p>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6">
              <div
                class="single-service-box mt-30 p-4 bg-white wow fadeIn item"
                data-wow-delay="0.4s"
                data-wow-duration="1s"
              >
                <div class="icon">
                  <!-- <i class="mdi mdi-responsive"></i> -->
                  <img src="../assets/images/icons/cyber.svg" alt="" />
                </div>
                <h3>Business Intelligence and Assessments​</h3>
                <p style="text-align:center;">
                  A key challenge – particularly with new companies – is
                  understanding where to begin. Whether it’s assessing
                  cybersecurity readiness or conducting an analysis of the
                  health of the supply chain, MoveAmerica can help. MoveAmerica
                  assists with conducting reviews of the industrial landscape
                  and its challenges, then recommends the appropriate courses of
                  action to position its partners for mission success.
                </p>
                <p style="text-align:center;">
                  We have a highly effective, tailored approach to assist
                  managers and executives in identifying and managing risks and
                  assessing regulatory compliance. By equipping managers and
                  executives with this information, we have a direct impact on
                  mitigating risks to the industrial base and associated supply
                  chains.
                </p>
              </div>
            </div>
            <div class="action">
              <div class="col-lg-6 col-md-6 col-sm-6">
                <div
                  class="single-service-box mt-30 p-4 bg-white wow fadeIn item"
                  data-wow-delay="0.6s"
                  data-wow-duration="1s"
                >
                  <div class="icon">
                    <!--  <i class="mdi mdi-rocket"></i> -->
                    <img
                      src="../assets/images/icons/hybrid-operations.svg"
                      alt=""
                    />
                  </div>
                  <h3>Consortia Development and Management</h3>
                  <p style="text-align:center;">
                    With extensive expertise in building and managing consortia,
                    MoveAmerica can assist across the spectrum of needs related
                    to consortia establishment, fundraising, membership
                    programs, and subject matter expert boards. MoveAmerica
                    brings together academia, industry, and government to solve
                    both acute and abstract challenges related to national
                    security within the U.S. industrial base. Furthermore, our
                    team includes the former Entrepreneur-in-Residence at UI
                    Labs and at the University of Maryland Baltimore County
                    (UMBC).
                  </p>
                  <p style="text-align:center;">
                    We know what it takes to lay the necessary foundation for
                    building successful public-private partnerships that include
                    project planning and strategy development, solicitation
                    management, project execution, demonstration, integration,
                    deployment, and commercialization.
                  </p>
                </div>
              </div>
            </div>
            <!--
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="single-service-box mt-30 p-4 bg-white wow fadeIn" data-wow-delay="0.8s" data-wow-duration="1s" style="height:260px">
                                <div class="icon">
									<img src="../assets/images/icons/techology-dev.svg" alt="">
                                </div>
                                <h3>Technology Development, Demonstration, and Integration for Major Defense Acquisition Systems</h3>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="single-service-box mt-30 p-4 bg-white wow fadeIn" data-wow-delay="1s" data-wow-duration="1s" style="height:260px">
                                <div class="icon">
									<img src="../assets/images/icons/training-mentoring.svg" alt="">
                                </div>
                                <h3>Workforce Development, Unique Skills Training, Mentoring​</h3>
                            </div>
                        </div>
						<div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="single-service-box mt-30 p-4 bg-white wow fadeIn" data-wow-delay="1s" data-wow-duration="1s" style="height:260px">
                                <div class="icon">
									<img src="../assets/images/icons/autonomous.svg" alt="">
                                </div>
                                <h3>Autonomous Systems, Next Generation Communications, Robotics</h3>
                            </div>
                        </div>
						<div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="single-service-box mt-30 p-4 bg-white wow fadeIn" data-wow-delay="1s" data-wow-duration="1s" style="height:260px">
                                <div class="icon">
									<img src="../assets/images/icons/EM.svg" alt="">
                                </div>
                                <h3>EM Spectrum Allocation and Scheduling, Battle Management, Distributed Intelligence, Failure Prognostics and Energy Management for Life Extension</h3>
                            </div>
                        </div>
						<div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="single-service-box mt-30 p-4 bg-white wow fadeIn" data-wow-delay="1s" data-wow-duration="1s" style="height:260px">
                                <div class="icon">
									<img src="../assets/images/icons/medical.svg" alt="">
                                </div>
                                <h3>Medical Technology, Advanced Materials</h3>
                            </div>
                        </div> -->
          </div>
        </div>
      </div>
    </section>
    <!-- Start Services Area -->
    <!-- <section class="section portfolio-section" id="portfolio">
		  <div class="container">
			<div class="section-title text-center z-index9">
                    <h2>I4NI Capability Areas​</h2>
					<p>
						I4NI offers a comprehensive platform of relevant national security expertise to address acknowledged and emerging challenges with solutions that can be applied quickly by the U.S. Department of Defense, Department of Homeland Security, and other Federal Agencies.
					</p>
                </div>
			</div>
            <div class="container">
                <div class="portfolio-items row no-gutters mt-4  wow fadeIn" data-wow-duration="1s">
                     <div class="col-lg-4 col-sm-6 portfolio-item">
                        <div class="image-border">
                            <div class="portfolio-box scale-image">
                                <img src="../assets/images/images/AI_ML.jpeg" class="img-fluid" alt="">
                                <div class="img-overlay text-white text-center">
                                    <h5 class="mb-0">Data science, Machine Learning, Artificial Intelligence ​</h5>
                                </div>
                            </div>
                        </div>
                    </div>
					<div class="col-lg-4 col-sm-6 portfolio-item">
                        <div class="image-border">
                            <div class="portfolio-box scale-image">
                                <img src="../assets/images/images/Analytics_Supply_Chain.jpeg" class="img-fluid" alt="">
                                <div class="img-overlay text-white text-center">
                                    <h5 class="mb-0">Supply Chain Assessments, Supply Chain Security, Cybersecurity, Physical System Protection​</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                     <div class="col-lg-4 col-sm-6 portfolio-item">
                        <div class="image-border">
                            <div class="portfolio-box scale-image">
                                <img src="../assets/images/images/defense_community.jpg" class="img-fluid" alt="">
                                <div class="img-overlay text-white text-center">
                                    <h5 class="mb-0">Hybrid Operations, Adversary Military Operations </h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-6 portfolio-item">
                        <div class="image-border">
                            <div class="portfolio-box scale-image">
                                <img src="../assets/images/images/Defense_Acq.jpeg" class="img-fluid" alt="">
                                <div class="img-overlay text-white text-center">
                                    <h5 class="mb-0">Technology Development, Demonstration, and Integration for Major Defense Acquisition Systems </h5>
                                </div>
                            </div>
                        </div>
                    </div>
					 <div class="col-lg-4 col-sm-6 portfolio-item">
                        <div class="image-border">
                            <div class="portfolio-box scale-image">
                                <img src="../assets/images/images/Curriculum_Development.jpeg" class="img-fluid" alt="">
                                <div class="img-overlay text-white text-center">
                                    <h5 class="mb-0">Workforce Development, Unique Skills Training, Mentoring</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-6 portfolio-item">
                        <div class="image-border">
                            <div class="portfolio-box scale-image">
                                <img src="../assets/images/images/Autonomous_Systems.jpeg" class="img-fluid" alt="">
                                <div class="img-overlay text-white text-center">
                                    <h5 class="mb-0">Autonomous Systems, Next Generation Communications, Robotics </h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-6 portfolio-item">
                        <div class="image-border">
                            <div class="portfolio-box scale-image">
                                <img src="../assets/images/images/EM_Spectrum.jpeg" class="img-fluid" alt="">
                                <div class="img-overlay text-white text-center">
                                    <h5 class="mb-0">EM Spectrum Allocation and Scheduling, Battle Management, Distributed Intelligence, Failure Prognostics and Energy Management for Life Extension</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-6 portfolio-item">
                        <div class="image-border">
                            <div class="portfolio-box scale-image">
                                <img src="../assets/images/images/medical_tech.jpeg" class="img-fluid" alt="">
                                <div class="img-overlay text-white text-center">
                                    <h5 class="mb-0">Medical Technology, Advanced Materials</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-6 portfolio-item">
                        <div class="image-border">
                            <div class="portfolio-box scale-image">
                                <img src="../assets/images/services/supply-chain-analytics-sm.jpeg" class="img-fluid" alt="">
                                <div class="img-overlay text-white text-center">
                                    <h5 class="mb-0">Emerging and Potential Disruptive Technologies​</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section> -->
    <section class="section">
      <div class="container">
        <div class="section-title text-center z-index9">
          <h2>Services</h2>
          <br />
          <br />
        </div>
        <div class="row">
          <div class="col-12">
            <div class="img-container">
              <img
                src="../assets/images/services.jpeg"
                alt=""
                class="img-fluid"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="d-flex">
              <div class="col-6">
                <ul>
                  <li>Project Planning and Acquisition Strategy Development</li>
                  <li>Technology Road-Mapping and Prototyping</li>
                  <li>Manufacturing Process Training</li>
                  <li>Technology Commercialization</li>
                  <li>Small Business Mentoring</li>
                </ul>
              </div>
              <div class="col-6">
                <ul>
                  <li>Solicitation Management</li>
                  <li>Analytics for Supply Chain Anomalies</li>
                  <li>Tailored Training</li>
                  <li>
                    Cybersecurity, Vulnerability Analysis, Incident Response
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: "services",
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.initFooterHeight();
      this.initPogressBar();
    },
    initFooterHeight() {
      var footerHeight = $("footer").outerHeight();
      $(".main-content").css("margin-bottom", footerHeight);
    },
    initPogressBar() {
      $(".bar-percentage[data-percentage]").each(function() {
        var progress = $(this);
        var percentage = Math.ceil($(this).attr("data-percentage"));
        $({ countNum: 0 }).animate(
          { countNum: percentage },
          {
            duration: 2000,
            easing: "linear",
            step: function() {
              // What todo on every count
              var pct = Math.floor(this.countNum) + "%";
              progress.text(pct) &&
                progress
                  .siblings()
                  .children()
                  .css("width", pct);
            },
          }
        );
      });
    },
  },
};
</script>
<style scoped>
.service {
  background: #d3d3d3;
}
.item {
  position: relative;
  height: 550px;
  overflow-y: scroll;
}
.action {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
</style>
